<template>
  <div class="specialDetail">
    <!-- 底部导航 -->
    <div class="artHead">
      <h1 class="title">{{viewData.title}}</h1>
      <div class="flexBox">
        <div class="boxLeft">
        </div>
        <div class="boxRight">浏览量:{{viewData.hits}}人次</div>
      </div>
    </div>
    <!-- <img class="pic" :src="adddom(viewData.thumb)"> -->
    <div style="overflow: hidden;" v-html="viewData.content"></div>
    <van-overlay :show="loadShow" style="z-index:900;">
      <div class="wld-wrapper" @click.stop>
        <div class="wld-block">
          <!-- <van-loading type="spinner" /> -->
          <van-loading size="24px" vertical>加载中...</van-loading>
        </div>
      </div>
    </van-overlay>
    <div style="height:3rem;"></div>
    <index-footer></index-footer>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import indexFooter from "../views/footer.vue";
export default {
  data() {
    return {
      loadNum: 0,
      loadShow: false,
      viewData: {},
      getCodeUrl:"http://speaker.shanmuzhi.com/api/wxcode?url=specialShare",
      memberUrl: "http://speaker.shanmuzhi.com/#/",
      shareUrl: require("../../public/statics/images/share.jpg"),
    };
  },
  components: {
    indexFooter
  },
  activated() {
  },
  mounted(){
  },
  created() {
    this.getCodeUrl = this.$publicData.domain + 'api/wxcode?url=specialShare'
    this.memberUrl = this.$publicData.domain + '#/'
    if(this.$route.query.id !=undefined){
      Cookies.set('spId', this.$route.query.id)  
    }
    let that = this
    var token = Cookies.get('spToken');
    if (token && token != undefined) {
      // 有token 直接展示
      that.loadNum++
      that.loadShow = true
      that.getDetail(this.$route.query.id)
      return;
    }
    // 判断是否已注册，如果注册则正常微信登录，如果没有则先注册。
    var codeArr = this.getUrlCode();
    // 获取code
    if (codeArr["code"] != undefined) {
        var code = codeArr["code"];
        var params = {
            code: code
        };
        // 绑定
        this.$api.index.wxlogin(params).then(res => {
            if (res.code == 200) {
                Cookies.set('spToken', res.result.token, { expires: 365 })
                localStorage.setItem('priv', JSON.stringify(res.result.priv))
                that.loadNum++
                that.loadShow = true
                that.getDetail(Cookies.get('spId'))
                // window.history.replaceState( null, null, that.memberUrl);
            }
        });
    }else{
      window.location.href = this.getCodeUrl;
    }
  },
  methods: {
    // 截取url中的code方法
    getUrlCode() {
        var allUrl = location.href;
        var url = allUrl.substring(allUrl.indexOf("?"), allUrl.length);
        this.winUrl = url;
        var theRequest = new Object();
        if (url.indexOf("?") != -1) {
            var str = url.substr(1);
            var strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
            }
        }
        return theRequest;
    },
    toBack() {
      this.$router.go(-1);
    },
    getDetail(id){
      let that = this
      let ps = {
        token: Cookies.get('spToken'),
        id: id
      }
      that.$api.special.detail(ps).then(res => {
        if (res.code == 200) {
          that.loadNum--
          if (that.loadNum==0){
            that.loadShow = false
          }
          that.viewData = res.result
          window.document.title = that.viewData.title
          // 分享
          let routeData = that.$router.resolve({
            path: '/specialShare',
            query: {
              id: that.viewData.id
            }
          })
          let tempurl = location.href;
          let shareUrl = that.$publicData.domain + routeData.href
          console.log(shareUrl)
          that.$api.index.getShare({url:tempurl}).then(function(res){
            if (res.code == 200) {
              let shareConfig = res.result;
              console.log(shareConfig);
              wx.config({
                debug: shareConfig.debug,
                beta: shareConfig.beta,
                jsApiList: shareConfig.jsApiList,
                appId: shareConfig.appId,
                nonceStr: shareConfig.nonceStr, // 随机串
                timestamp: parseInt(shareConfig.timestamp), // 时间戳
                signature: shareConfig.signature // 签名
              });
              wx.ready(function () {
                var shareDataA = {
                  title: that.viewData.title, // 分享标题
                  desc: that.viewData.describe, // 分享描述
                  link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: that.adddom(that.viewData.thumb) || that.$publicData.shareImg, // 分享图标
                  success: function () {
                  },
                  cancel: function (e) {
                  }
                }
                var shareDataB = {
                  title: that.viewData.title, // 分享标题
                  link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: that.adddom(that.viewData.thumb) || that.$publicData.shareImg, // 分享图标
                  success: function () {
                  },
                  cancel: function (e) {
                  }
                }
                setTimeout(function(){
                  wx.updateAppMessageShareData(shareDataA); // 分享给朋友
                  wx.updateTimelineShareData(shareDataB); // 分享到朋友圈
                },2000)
              })
            }
          })
        }
      })
    },
    adddom (src) {
      if (src == '' || src == undefined || src == null) {
        console.log('src地址有问题')
        return ''
      }
      if (src.substr(0, 4).toLowerCase() === 'http') {
        return src
      }
      return this.$imgurl + src
    },
  }
};
</script>
<style scoped>
.specialDetail{
  width: 100%;
  min-height: 100vh;
  padding: 0.52rem 0.4rem;
  padding-bottom: 1.5rem;
}
.specialDetail .artHead .title{
  font-size: 0.48rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
}
.specialDetail .artHead .flexBox{
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 0.4rem;
  margin-bottom: 0.5rem;
}
.specialDetail .artHead .flexBox .boxLeft{
  display: inline-flex;
  align-items: center;
}
.specialDetail .artHead .flexBox .boxLeft img{
  width: 0.93rem;
  height: 0.93rem;
  border-radius: 50%;
  margin-right: 0.2rem;
}
.specialDetail .artHead .flexBox .boxLeft h2{
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
}
.specialDetail .artHead .flexBox .boxLeft p{
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.5);
}
.specialDetail .artHead .flexBox .boxRight{
  line-height: 0.54rem;
  background: #F6F6F6;
  font-size: 0.27rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  padding: 0 0.1rem;
}
.specialDetail .cont{
  font-size: 0.4rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
  text-indent: 2em;
  margin-top: 0.3rem;
}
.specialDetail .pic{
  display: block;
}
</style>